export default __webpack_public_path__ + "static/media/902.e864ae13.jpg";